import * as React from 'react';
import { useMemo } from 'react';
import * as Immutable from 'immutable';

import type FieldTypeMapping from 'views/logic/fieldtypes/FieldTypeMapping';
import useFieldTypes from 'data-lake/hooks/useFieldTypes';
import { Spinner } from 'components/common';
import FieldTypesContext from 'views/components/contexts/FieldTypesContext';

const FieldTypesProvider = ({ children }: React.PropsWithChildren) => {
  const { isInitialLoading: isLoadingFields, data: fieldTypes } = useFieldTypes();
  const fieldTypesContextValue = useMemo(
    () => ({
      all: Immutable.List(fieldTypes) ?? Immutable.List(),
      currentQuery: Immutable.List<FieldTypeMapping>(),
    }),
    [fieldTypes],
  );

  if (isLoadingFields) {
    return <Spinner />;
  }

  return <FieldTypesContext.Provider value={fieldTypesContextValue}>{children}</FieldTypesContext.Provider>;
};

export default FieldTypesProvider;
